import { z } from "zod";

export const ZSetUserPropertyBulkBody = z.object({
  emails: z
    .array(z.string().min(1))
    .nonempty('At least one email is required')
    .max(500, 'A maximum of 500 emails may be sent per request'),
  propertyName: z.string().min(1, 'Property name is required'),
  propertyValue: z.string().min(1, 'Property value is required'),
});

export const ZSetUserPropertyBulkResponse = z.object({
  total: z.number().int().nonnegative(),
  succeededCount: z.number().int().nonnegative(),
  notFound: z.number().int().nonnegative(),
  failed: z.array(
    z.object({
      email: z.string(),
      error: z.string(),
    }),
  ),
});

export type SetUserPropertyBulkBody = z.infer<typeof ZSetUserPropertyBulkBody>;
export type SetUserPropertyBulkResponse = z.infer<
  typeof ZSetUserPropertyBulkResponse
>;